import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer from './slices/rootReducer';

import saveAuthToken from './middleware/auth-middleware';

// Nothing sensitive may ever reach localStorage: tokens, profile, medical and
// appointment data are XSS-readable there (pentest finding 1.1). State is kept
// in memory only; on reload the session is restored via Auth0 silent auth and
// data is re-fetched from the API (see Root.js).
const persistConfig = {
  key: 'root',
  version: 2,
  storage,
  whitelist: [],
}

// Purge state persisted to localStorage by previous app versions.
localStorage.removeItem('persist:root');

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  }).concat(saveAuthToken)
})

let persistor = persistStore(store);

export { store, persistor };
